import { ArticleData } from 'model/Article';
import { useI18n } from 'next-localization';
import React from 'react';

type ArticleContributorsProps = {
  contributors: ArticleData['articleContributor']['targetItems'];
  className?: string;
};

const ArticleContributors: React.FC<ArticleContributorsProps> = ({ contributors, className }) => {
  const { t } = useI18n();
  const contributorNames = contributors.map((c) => c.name.value).join(', ');

  return (
    <div className={className}>
      <div className="footnote footnote--bold text-grey">{t('contributors')}</div>
      <div className="mt-1 body-small text-grey">{contributorNames}</div>
    </div>
  );
};

export default ArticleContributors;
